export const TASK_DEEP_LINK_PARAM = 'task';

export function taskDeepLinkPath(taskId: string): string {
  return `/taches?${TASK_DEEP_LINK_PARAM}=${encodeURIComponent(taskId)}`;
}

export function parseTaskDeepLink(search: string | URLSearchParams): string | null {
  const sp =
    typeof search === 'string'
      ? new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
      : search;
  const id = sp.get(TASK_DEEP_LINK_PARAM)?.trim() ?? '';
  return id.length > 0 ? id : null;
}

export function withoutTaskDeepLink(sp: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(sp);
  next.delete(TASK_DEEP_LINK_PARAM);
  return next;
}
